import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';
import {AlertController, ToastController} from "ionic-angular";

/**
 * A simple settings/config class for storing key/value pairs with persistence.
 */
@Injectable()
export class SettingsProvider {
  _readyPromise: Promise<any>;
  DECIMAL_SEPARATOR = ".";
  GROUP_SEPARATOR = ",";
  pureResult: any;
  maskedId: any;
  val: any;
  v: any;
  private SETTINGS_KEY: string = '_settings';
  private DATA_KEY: string = '_offData';

  constructor(
    public storage: Storage,
    public toastCtrl: ToastController,
    public alertCtrl: AlertController) {

  }

  saveCachedData(key: string, chv: any) {
    this.storage.set(this.DATA_KEY + '.' + key, chv);
  }

  loadCachedData(key: string) {
    return this.storage
      .get(this.DATA_KEY + '.' + key)
      .then((data) => {
        return (data != undefined && data.value != undefined ? data.value : data);
      });
  }

  loadCachedDataPromise(key: string) {
    return new Promise(resolve => {
      return this.storage.get(this.DATA_KEY + '.' + key).then((value: any) => {
        resolve(value);
      });
    });
  }

  saveSetting(key: string, chv: any) {
    this.storage.set(this.SETTINGS_KEY + '.' + key, chv);
  }

  loadSetting(key: string) {
    return new Promise(resolve => {
      return this.storage.get(this.SETTINGS_KEY + '.' + key).then((value: any) => {
        resolve(value);
      });
    });
  }

  eraseData() {
    this.storage.forEach((value, key, index) => {
      if (key.indexOf(this.DATA_KEY) == -1) {
        this.storage.remove(key);
      }
    });
    // this.storage.clear();
  }

  showToastWithCloseButton(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      showCloseButton: true,
      position: "top",
      closeButtonText: "FECHAR"
    });
    toast.present();
  }

  showToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "bottom"
    });

    toast.present(toast);
  }

  presentAlert(title: string, message: string) {
    let alert = this.alertCtrl.create(
      {
        title: title,
        subTitle: message,
        buttons: [
          {
            text: 'OK'
          }
        ]
      })
    return alert.present();
  }

  AlertDimiss(title: string, message: string) {
    return this.alertCtrl.create(
      {
        title: title,
        subTitle: message,
        buttons: [
          {
            text: 'OK'
          }
        ]
      })
  }

  getSiglaEmp(codmoe) {
    return new Promise((resolve, reject) => {
      this.loadCachedData("s_moeda").then((res: any) => {
        if (res) {
          for(let i = 0; i < res.length; i++) {
            if(res[i].optKey == codmoe) {
              resolve(res[i].optVal);
            }
          }
          resolve('');
        }
        resolve('');
      });
    });
  }

  getEmpFil() {
    return new Promise((resolve, reject) => {
      this.loadSetting("infocon").then((res: any) => {
        if (res) {
          resolve(res.CODEMP + "-" + res.CODFIL);
        }
        resolve('');
      });
    });
  }

  isNumber(n) {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  }

}



// WEBPACK FOOTER //
// ./src/providers/settings.ts